import api from './api'

export const rolesAPI = {
  // Get role statistics for dashboard
  getStats: () => api.get('/roles/stats/overview'),
  
  // Get all roles
  getAll: (params = {}) => api.get('/roles', { params }),
  
  // Get role by ID
  getById: (id) => api.get(`/roles/${id}`),
  
  // Create new role
  create: (roleData) => api.post('/roles', roleData),
  
  // Update role
  update: (id, roleData) => api.put(`/roles/${id}`, roleData),
  
  // Delete role
  delete: (id) => api.delete(`/roles/${id}`),
  
  // Get role permissions
  getPermissions: (id) => api.get(`/roles/${id}/permissions`),
  
  // Update role permissions
  updatePermissions: (id, permissions) => api.patch(`/roles/${id}/permissions`, { permissions })
}



